import React from "react";
import { Link } from "react-router-dom";
import 'styles/common.css';
import './Membership.css';

const Membership = () => {
  const plans = [
    { 
      name: "Basic", 
      price: "Free", 
      features: ["1 Project", "Basic Support", "Limited Tokens"],
      popular: false
    },
    { 
      name: "Education", 
      price: "$129.99/mo", 
      features: ["Unlimited Projects", "Dedicated Support", "Limited Tokens"],
      popular: false
    },
    { 
      name: "Pro", 
      price: "$169.99/mo", 
      features: ["Unlimited Projects", "Priority Support", "Limited Tokens"],
      popular: true
    },
    { 
      name: "Enterprise", 
      price: "Custom", 
      features: ["Unlimited Projects", "Anytime Assistance", "Custom Solutions"],
      popular: false
    },
  ];

  return (
    <div className="membership-page">
      <div className="membership-container">
        <h1 className="membership-title">Membership Plans</h1>
        <p className="membership-subtitle">Choose the plan that fits your research needs</p>
        
        <div className="membership-grid">
          {plans.map((plan, i) => {
            const isEnterprise = plan.name === "Enterprise";
            const CardTag = isEnterprise ? Link : 'div';
            const cardLinkProps = isEnterprise ? { to: "/request-quote" } : {};
            return (
              <CardTag
                key={i}
                className={`price-card ${plan.popular ? 'popular' : ''} ${isEnterprise ? 'clickable' : ''}`}
                {...cardLinkProps}
              >
                {plan.popular && <div className="popular-badge">Most Popular</div>}
                <h2 className="plan-name">{plan.name}</h2>
                <p className="price-tag">{plan.price}</p>
                <ul className="feature-list">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="feature-item">
                      <span className="feature-check">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </CardTag>
            );
          })}
        </div>

        <div className="membership-footer">
          <p>All plans include access to our AI-driven drug discovery platform and quantum mechanics integration</p>
        </div>
      </div>
    </div>
  );
};

export default Membership;